import { useContext, useMemo } from 'react'

import { Divider } from '@mantine/core'

import { useAuth } from 'src/auth'
import Tag from 'src/components/DataDisplay/Tag/Tag'
import FilterMenu from 'src/components/Overlays/FiltersMenu/FilterMenu'
import { RecruitersContext } from 'src/context/RecruitersContext'
import IconCheckmark from 'src/icons/IconCheckmark'

const DashboardHeader = ({
  name,
  selectedRecruiters,
  setSelectedRecruiters,
}) => {
  const { currentUser } = useAuth()
  const recruiters = useContext(RecruitersContext)
  const fullName = `${currentUser?.firstName} ${currentUser?.lastName}`

  // Sort employees alphabetically by label
  const sortedEmployees = useMemo(() => {
    return [...(recruiters || [])].sort((a, b) =>
      a.label.localeCompare(b.label)
    )
  }, [recruiters])

  const filters = [
    {
      title: 'Employees',
      selected: selectedRecruiters.map((r) => r.value),
      onChange: (values) => {
        const selected = sortedEmployees.filter((employee) =>
          values.includes(employee.value)
        )
        setSelectedRecruiters(selected)
      },
      options: sortedEmployees,
      alphabetize: true,
    },
  ]

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col justify-between gap-3 text-doubleNickel-brand-500 sm:flex-row">
        <div className="text-lg font-semibold">Welcome, {name}!</div>
        <div className="flex flex-row items-center gap-2">
          <div className="text-xs font-medium text-doubleNickel-gray-700">
            Suggested:
          </div>
          <Tag
            clickable={true}
            onClick={() => {
              if (
                selectedRecruiters.find(
                  (recruiter) => recruiter.value === currentUser.employeeId
                )
              ) {
                // Remove the recruiter
                setSelectedRecruiters(
                  selectedRecruiters.filter(
                    (recruiter) => recruiter.value !== currentUser.employeeId
                  )
                )
              } else {
                // Add the recruiter
                setSelectedRecruiters([
                  ...selectedRecruiters,
                  {
                    label: fullName,
                    value: currentUser.employeeId,
                  },
                ])
              }
            }}
            showCloseButton={false}
          >
            {selectedRecruiters.find(
              (recruiter) => recruiter.value === currentUser.employeeId
            ) && (
              <IconCheckmark className="h-3 w-3 fill-none stroke-doubleNickel-brand-400" />
            )}
            {fullName}
          </Tag>
          <Divider orientation="vertical" />
          <FilterMenu filters={filters} />
        </div>
      </div>
    </div>
  )
}

export default DashboardHeader
